"use strict";

exports.__esModule = true;
exports.useWatch = useWatch;

var _react = require("react");

var _utils = require("@bydesign-ui/utils");

var _hooks = require("@bydesign-ui/hooks");

var _form = require("../../../hooks/form");

var _useForm = require("./useForm");

function useWatch(keys, fn, lazy) {
  if (lazy === void 0) {
    lazy = false;
  }

  var form = (0, _useForm.useForm)();
  var scope = (0, _form.useFormScope)();
  var id = (0, _hooks.useSingleton)(function () {
    return (0, _utils.guid)();
  });
  var getter = (0, _hooks.useRefGetter)(fn);
  (0, _react.useEffect)(function () {
    var callback = function callback(changes, flags) {
      var fn = getter();
      fn(form, changes, flags);
    };

    form.watch(id, scope, keys, callback, lazy);
    return function () {
      return form.unwatch(id);
    };
  }, keys);
}